import { defineStore } from 'pinia';
import genericAPI from "@/api/api";
import { UserFileFolder, type UserFileEntry  } from "@typesDef/user.types";
export const useUserFilesStore = defineStore('userFiles', {
    state: () => ({
        currentFiles: {
            profile: null as UserFileEntry[] | null,
            event: null as UserFileEntry[] | null,
            contract: null as UserFileEntry[] | null,
            audio: null as UserFileEntry[] | null
        },
    }),
    actions: {
        clearMyData(): void {
            this.currentFiles = null
        },
        /**
         * Fetch the current user from the backend
         * If force is true, the user will be fetched from the backend even if it is already in the store
         * @param force
         * @param folder - optional folder to fetch files from
         */
        async fetchCurrentUserFiles(force: boolean = false, folder: string = ""): Promise<[]> {
            log.debug(`fetchCurrentUserFiles force=${force} folder=${folder}`);
            if (!this.currentFiles || (folder && !this.currentFiles[folder]) || force) {
                if (folder) {
                    this.currentFiles[folder] = await genericAPI.getDocument<[]>(`users/current/files/${folder}`);
                } else {
                    this.currentFiles = {
                        profile: await genericAPI.getDocuments<UserFileEntry>(`users/current/files/profile`),
                        event: await genericAPI.getDocuments<UserFileEntry>(`users/current/files/event`),
                        contract: await genericAPI.getDocuments<UserFileEntry>(`users/current/files/contract`),
                        audio: await genericAPI.getDocuments<UserFileEntry>(`users/current/files/audio`)
                    }
                }
                return (folder ? this.currentFiles[folder] : this.currentFiles) || [];
            }
        }
    }
});
